var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32738 0.997641C1.49815 0.997061 1.66688 1.03475 1.82117 1.10794C1.97546 1.18113 2.11139 1.28796 2.21897 1.42058L7.73997 8.27895C7.90809 8.48348 8 8.74004 8 9.0048C8 9.26956 7.90809 9.52611 7.73997 9.73064L2.02465 16.589C1.83063 16.8225 1.55182 16.9692 1.24957 16.9971C0.947313 17.025 0.646366 16.9316 0.412933 16.7376C0.179501 16.5436 0.0327044 16.2648 0.00483656 15.9625C-0.0230312 15.6603 0.0703135 15.3593 0.264335 15.1259L5.37383 8.99908L0.435795 2.87226C0.296018 2.70448 0.207228 2.50017 0.179933 2.2835C0.152637 2.06684 0.187976 1.84688 0.281772 1.64967C0.375566 1.45246 0.52389 1.28625 0.709193 1.1707C0.894495 1.05514 1.10902 0.995089 1.32738 0.997641Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGrey);
export default __webpack_public_path__ + "static/media/arrow-right-grey.fca54fb12b795a7118bd27e356c4eb50.svg";
export { ForwardRef as ReactComponent };